export const FETCH_LIST_CHURCH = "FETCH_LIST_CHURCH";
export const FETCH_LIST_CHURCH_DATA = "FETCH_LIST_CHURCH_DATA";
